import {injectable} from "tsyringe";
import {DeleteIssueStatusCommand} from "../commands/delete-issue-status.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

/**
 * Transforms a DeleteIssueStatusCommand into a DTO payload for the backend save endpoint.
 * Extracts the UID from the IssueStatus entity carried by the command.
 */
@injectable()
@transformer({source: DeleteIssueStatusCommand, target: `dto`})
export class DeleteIssueStatusCommandToDtoTransformer extends AbstractCommandToDtoTransformer<IssueStatus> {

    protected async toDTO(issueStatus: IssueStatus): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{uid: issueStatus.uid});
    }

}
